import React, { useState } from "react";
import { Link } from "react-router-dom";
import { getWithExpiry, setWithExpiry } from '../../common';
import { useCookies } from "react-cookie";
import configVars from "../../config";

const DismissableAlert = (props) => {

    const [show, setShow] = useState(true);
	const [cookies] = useCookies(["sustainyou_user_jwt"]);

	let bgColor = 'sea-green';
	let textColor = 'white';

	if ( props?.data?.bg_color ) {
		bgColor = props.data.bg_color;
	}

	if ( props?.data?.text_color ) {
		textColor = props.data.text_color;
	}

	let alertClosed = null;

	if ( props?.data?.id ) {
		alertClosed = getWithExpiry(  `alert_${props?.data?.id}_closed` );
	}


	const handleClose = async () => {

		setShow(false);

        if (cookies.sustainyou_user_jwt && props?.data?.id ) {

				let userRequestData = new FormData();
				userRequestData.append( 'token', cookies.sustainyou_user_jwt );
				userRequestData.append( 'meta_key',  `alert_${props?.data?.id}_closed`);
				userRequestData.append( 'meta_value', 'yes' );
                
                try {
                    const response = await fetch(
                        `${configVars.apiUrl}sustainchange/v1/updateusermetadata/`,
                        {
                            method: "POST",
                            headers: {
                                Authorization: `Basic ${configVars.auth}`,
                            },
							body: userRequestData
                        }
                    );
            
                    const userResponse = await response.json();
                    
                    if ( userResponse ) {

                        if ( userResponse.success === true ) {
							
							setWithExpiry(  `alert_${props?.data?.id}_closed`, 'yes' );
							//console.log(  userResponse );

                        }
                    }

                } catch (error) {
                    console.log({ error });
                }
        }

    }

    return (
		<>
			{ show && alertClosed !== 'yes' &&
				 <div className={`alert alert-dismissible d-flex ${show ? 'show' : ''} bg-${bgColor} text-${textColor}`} role="alert">
					{props?.data?.content?.strong &&
						<strong className="pe-2">{props?.data?.content?.strong}</strong>
					}

					{props?.data?.content?.text &&
						<div dangerouslySetInnerHTML={{__html: props?.data?.content?.text}}></div>
					}

					{props?.data?.content?.link &&
						<Link to={props?.data?.content?.link?.url} className="alert-link ps-3">{props?.data?.content?.link?.text}</Link>
					}
					
					<button type="button" className="btn-close text-white pt-3" data-bs-dismiss="alert" aria-label="Close" onClick={() => handleClose()} style={{background: 'none'}}>
						<i className="fa fa-times fa-lg" aria-hidden="true"></i>
					</button>
			 </div>
			}
		</>
    )

}

export default DismissableAlert;